exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.options[data-v-55cd9636]{display:flex;flex-wrap:wrap;justify-content:flex-start;gap:20px\n}", ""]);

// exports
